import img1 from "../../Quiz-app/images/img.png";
import img2 from "../../Quiz-app/images/about.png";
import img3 from "../../Quiz-app/images/terms-and-conditions.png";
import { formatDurationNew, formatText1 } from "../../Quiz-app/utilss/utils";
import logo from "../../Quiz-app/images/docmaster.png";

export default function TermsAndConditions2({ quizDetails }) {
  //   const location = useLocation();
  //   const { quizDetails } = location.state || {};
  function convertTermsToHtml(text) {
    if (!text) return "";

    // ✅ Step 1: Replace placeholders with quizDetails values
    let replaced = text
      .replace(/\[Number\]/g, quizDetails?.total_questions ?? "")
      .replace(
        /\[X seconds\]/g,
        quizDetails?.total_questions && quizDetails?.duration_per_question
          ? quizDetails.total_questions * quizDetails.duration_per_question
          : ""
      )
      .replace(/\[X second\]/g, quizDetails?.duration_per_question ?? "")
      .replace(
        /\[Correct\]/g,
        `${quizDetails?.marks_per_question} mark(s)` ?? ""
      );

    // ✅ Step 2: Bold *text* -> <strong>text</strong>
    replaced = replaced.replace(/\*([^*\n]+?)\*/g, "<strong>$1</strong>");

    // ✅ Step 3: Convert new lines -> <br/>
    replaced = replaced.replace(/\r?\n/g, "<br/>");

    return replaced;
  }

  function formatTerms(text) {
    if (!text) return "";

    // 🔄 Replace placeholders with quizDetails values
    let replaced = text
      .replace(/\[Number\]/g, quizDetails?.total_questions)
      .replace(
        /\[X seconds\]/g,
        quizDetails.total_questions * quizDetails.duration_per_question
      )
      .replace(/\[X second\]/g, quizDetails.duration_per_question)
      .replace(/\[Correct\]/g, quizDetails.correct);

    const lines = replaced.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }

  function formatDate(dateString) {
    if (!dateString) return "-"; // Handle empty/null

    return new Date(dateString).toLocaleString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }

  function formatText(text) {
    return text
      .split("\n\n") // split paragraphs
      .map(
        (para) =>
          `<p style="margin-bottom: 1em;">${para
            .replace(/\n/g, "<br/>")
            .replace(/\*(.*?)\*/g, "<strong>$1</strong>") // <-- here
            .trim()}</p>`
      )
      .join("");
  }
  return (
    <div className="justify-content-center align-items-center">
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "10px",
          padding: 0,
          margin: 0,
          width: "100%",
        }}
      >
        {/* ===== Header ===== */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ccc",
            paddingBottom: 0, // ✅ no white band
            marginBottom: 0, // ✅ no outer gap
          }}
        >
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            {quizDetails.quiz_type === 2 && (
              <img
                src={`https://web1024.docmaster.in:5007/${quizDetails.image_url}`}
                alt="Quiz Icon"
                style={{
                  width: "50px",
                  height: "50px",
                  marginRight: "10px",
                  borderRadius: "50%",
                  padding: "5px",
                }}
              />
            )}
            <h2
              style={{
                margin: 0,
                padding: "10px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              {quizDetails?.title}
            </h2>
          </div>
        </div>
        {/* ===== Image / Card Section ===== */}

        {/* // backgroundSize: "cover", */}
        <div
          style={{
            position: "relative",
            // backgroundImage: `url(${img1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            width: "125%",
            height: "50vh",

            margin: 0,
            color: "#fff",
            display: "flex",
          }}
        >
          {/* Left DocMaster panel (only for type 1) */}

          <img
            src={img1}
            style={{ width: "100%", height: "350px", objectFit: "fill" }}
          />
          <div
            style={{
              display: "flex",
              alignItems: "flex-start", // top align
              justifyContent: "flex-start", // push content to the left
              position: "absolute",
              top: 0,
              left: 0,
              height: "10%",
              width: "100%", // fill the area
              paddingLeft: "20px",
              marginTop: "5%",
              marginLeft: "2%",
              // border: "1px solid black",
            }}
          >
            <div className="text-start">
              <div
                className="bg-white p-2 rounded"
                style={{ width: "fit-content" }}
              >
                <img src={logo} alt="DocMaster" style={{ width: "120px" }} />
              </div>
              <div className="mt-3 text-white me-5 mb-4">
                <h2 className="text-base font-semibold" style={{ margin: 0 }}>
                  All in One Solution for Advocates
                </h2>
                <a
                  href="/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-blue-300 underline hover:text-black-400"
                >
                  www.Docmaster.Legal
                </a>
              </div>
            </div>
            <div
              style={{
                marginLeft: "25%",
                // width: "90%",
                // border: "1px solid red",
              }}
            >
              {quizDetails.quiz_type === 1 && (
                <>
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: 600,
                      display: "block",
                      lineHeight: 1.2,
                      margin: 0,
                      textAlign: "center",
                    }}
                  >
                    Registration Details
                  </span>
                  <p style={{ fontSize: 16, fontWeight: 600, margin: "2px 0" }}>
                    Start Date :{" "}
                    {formatDate(quizDetails?.registration_start_date)}
                  </p>
                  <p style={{ fontSize: 16, fontWeight: 600, margin: "2px 0" }}>
                    End Date : {formatDate(quizDetails?.registration_end_date)}
                  </p>
                  <span
                    style={{
                      fontSize: 16,
                      fontWeight: 600,
                      display: "block",
                      margin: "2px 0",
                    }}
                  >
                    Quiz Date : {formatDate(quizDetails?.start_date)}
                  </span>
                </>
              )}

              <div
                style={{
                  marginTop: quizDetails.quiz_type === 2 ? "30%" : "10px",
                  display: "flex",
                  justifyContent: "center",
                  gap: 20,
                }}
              >
                <div
                  className="mt-3"
                  style={{
                    // backgroundColor: "rgba(55,65,81,0.8)",
                    backgroundColor: "#d9ac00",
                    color: "black",
                    padding: "5px 20px",
                    borderRadius: 6,
                    minWidth: 120,
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: 18, fontWeight: "bold" }}>
                    {quizDetails?.total_questions || "-"}
                  </div>
                  <div style={{ fontSize: 12 }}>QUESTIONS</div>
                </div>

                <div
                  className="mt-3"
                  style={{
                    // backgroundColor: "rgba(55,65,81,0.8)",
                    backgroundColor: "#d9ac00",
                    color: "black",
                    padding: "5px 20px",
                    borderRadius: 6,
                    minWidth: 120,
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "18px" }}>
                    {quizDetails?.total_questions &&
                    quizDetails?.duration_per_question
                      ? formatDurationNew(
                          quizDetails.total_questions *
                            quizDetails.duration_per_question
                        )
                          // Split into numbers and non-numbers
                          .split(/(\d+)/)
                          .map((part, i) =>
                            /^\d+$/.test(part) ? (
                              <span key={i} style={{ fontWeight: "bold" }}>
                                {part}
                              </span>
                            ) : (
                              <div style={{ fontSize: 12, display: "block" }}>
                                {" "}
                                <span key={i}>{part}</span>
                              </div>
                            )
                          )
                      : "-"}
                  </div>
                  {/* <div style={{ fontSize: 18, fontWeight: "bold" }}>
                    {quizDetails?.total_questions &&
                    quizDetails?.duration_per_question
                      ? quizDetails.total_questions *
                        quizDetails.duration_per_question
                      : "-"}{" "}
                  </div>
                  <div style={{ fontSize: 12 }}>SECONDS</div> */}
                </div>
              </div>
            </div>
          </div>

          {/* Right registration / stats */}
          <div className="px-3 py-4">
            {quizDetails.quiz_type === 1 && (
              <>
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    display: "block",
                    lineHeight: 1.2,
                    margin: 0,
                  }}
                >
                  Registration Details
                </span>
                <p style={{ fontSize: 16, fontWeight: 600, margin: "2px 0" }}>
                  Start Date :{" "}
                  {formatDate(quizDetails?.registration_start_date)}
                </p>
                <p style={{ fontSize: 16, fontWeight: 600, margin: "2px 0" }}>
                  End Date : {formatDate(quizDetails?.registration_end_date)}
                </p>
                <span
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    display: "block",
                    margin: "2px 0",
                  }}
                >
                  Quiz Date : {formatDate(quizDetails?.start_date)}
                </span>
              </>
            )}

            <div
              style={{
                marginTop: quizDetails.quiz_type === 2 ? "30%" : "10px",
                display: "flex",
                justifyContent: "center",
                gap: 20,
              }}
            >
              <div
                className="mt-3"
                style={{
                  // backgroundColor: "rgba(55,65,81,0.8)",
                  backgroundColor: "#d9ac00",
                  color: "black",
                  padding: "5px 20px",
                  borderRadius: 6,
                  minWidth: 120,
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: 18, fontWeight: "bold" }}>
                  {quizDetails?.total_questions || "-"}
                </div>
                <div style={{ fontSize: 12 }}>QUESTIONS</div>
              </div>

              <div
                style={{
                  backgroundColor: "#d9ac00",
                  color: "black",
                  padding: "5px 20px",
                  borderRadius: 6,
                  minWidth: 120,
                  textAlign: "center",
                }}
              >
                <div style={{ fontSize: 18, fontWeight: "bold" }}>
                  {quizDetails?.total_questions &&
                  quizDetails?.duration_per_question
                    ? quizDetails.total_questions *
                      quizDetails.duration_per_question
                    : "-"}
                </div>
                <div style={{ fontSize: 12 }}>SECONDS</div>
              </div>
            </div>
          </div>
        </div>
        {/* About Quiz */}
        <div style={{ overflow: "auto", height: "35vh", padding: "20px" }}>
          <div
            style={{
              // marginTop: "30px",
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src={img2}
              alt="About Icon"
              style={{ width: "30px", height: "30px" }}
            />
            <h3 style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}>
              About Quiz
            </h3>
          </div>
          {quizDetails.about_quiz ? (
            <div
              style={{ fontSize: "14px", marginTop: "10px", lineHeight: "1.6" }}
              dangerouslySetInnerHTML={{
                __html: formatText(quizDetails.about_quiz),
              }}
            />
          ) : (
            "-"
          )}
          <br />
          {quizDetails.quiz_type === 1 && (
            <div>
              <div
                style={{
                  marginTop: "10px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <h3 style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}>
                  Winner Prize Details
                </h3>
              </div>
              {/* <p style={{ fontSize: "14px" }}></p> */}
              {quizDetails.prizes ? (
                <div
                  style={{ marginTop: "10px", lineHeight: "1.6" }}
                  dangerouslySetInnerHTML={{
                    __html: formatText1(quizDetails.prizes),
                  }}
                />
              ) : (
                "-"
              )}
            </div>
          )}

          {quizDetails.quiz_type === 1 && (
            <div
              style={{
                marginTop: "30px",
                // display: "flex",
                // alignItems: "center",
                gap: "8px",
              }}
            >
              <h3 style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}>
                {" "}
                Eligibility Notice:
              </h3>{" "}
              <p style={{ fontSize: "14px", marginTop: "1%" }}>
                {" "}
                Participants must achieve a minimum score of 30% on the quiz to
                qualify for winner selection. Only those meeting this criteria
                will be considered
              </p>
            </div>
          )}
          <div
            style={{
              marginTop: "30px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <img
              src={img3}
              alt="About Icon"
              style={{ width: "30px", height: "30px" }}
            />
            <h3 style={{ fontSize: "16px", fontWeight: "bold", margin: 0 }}>
              Terms & Conditions
            </h3>
          </div>
          {quizDetails.quiz_terms ? (
            <div
              style={{ marginTop: "10px", lineHeight: "1.6", fontSize: "14px" }}
              dangerouslySetInnerHTML={{
                __html:
                  quizDetails.quiz_type === 1
                    ? convertTermsToHtml(quizDetails.quiz_terms)
                    : formatTerms(quizDetails.quiz_terms),
              }}
            />
          ) : (
            "-"
          )}
        </div>
      </div>
    </div>
  );
}
